import { Skeleton } from 'primereact/skeleton';
import classes from './drugTabContent.module.scss';

const DrugTabContentSkeleton = () => {
  return (
    <div className={classes.tabSkeletonSkeleton}>
      <Skeleton height="2rem" width="5rem"></Skeleton>
      <div className={classes.tabSkeletonTable}>
        <Skeleton height="8rem"></Skeleton>
        <Skeleton height="8rem"></Skeleton>
      </div>
    </div>
  );
};

export default DrugTabContentSkeleton;
